export default "/_nuxt/56243adf0d14f3c2e83822dd56903673.svg";